import { CHAT_SCREEN_MODE } from "MessagingV2/modules/Utils";

export const SQUARE_THUMBNAIL_RESOLUTION = {
  width: 300,
  height: 300,
};

export const calculateAspectRatioFit = ({
  srcWidth,
  srcHeight,
  maxWidth = 400,
  maxHeight = 300,
}) => {
  const ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight);

  return {
    width: Math.floor(srcWidth * ratio),
    height: Math.floor(srcHeight * ratio),
  };
};

export const MEDIA_DIMENSIONS_PER_VIEW_MODE = {
  [CHAT_SCREEN_MODE.WIDGET]: {
    width: 125,
    height: 125,
  },
  [CHAT_SCREEN_MODE.FULL_SCREEN]: {
    width: 170,
    height: 170,
  },
  [CHAT_SCREEN_MODE.SIDE_PANE]: {
    width: 170,
    height: 170,
  },
  [CHAT_SCREEN_MODE.VIEW_MODE_SCREEN]: {
    width: 170,
    height: 170,
  },
};
